import { Stack } from "@mui/material";
import { Title } from "@src/appV2/redesign/components/Title";

import { SupportArticleLink } from "./SupportArticleLink";
import { type SupportArticle } from "./types";

interface SupportArticleGroupProps {
  title: string;
  supportArticles: SupportArticle[];
}

export function SupportArticleGroup(props: SupportArticleGroupProps) {
  const { title, supportArticles } = props;

  return (
    <Stack spacing={1}>
      <Title bold component="h6" variant="h6">
        {title}
      </Title>
      {supportArticles.map((article) => (
        <SupportArticleLink key={article.attributes.distributionUrl} supportArticle={article} />
      ))}
    </Stack>
  );
}
